import { PreferenceState } from './preference-state';
import type { IUserGovernanceConfig } from './types';

export const defaultUserGovernanceConfig: IUserGovernanceConfig = {
  // If the expiration date is set and it is in the past, do not show the component
  // set the value with the format: new Date('2023/12/31')
  expirationDate: null,
  [PreferenceState.INIT]: {
    // cooldownDays is the number of days after the user can see the component again
    cooldownDays: 0,
    // secondaryButtonText is the text that will be displayed on the secondary button
    secondaryButtonText: _TL_('Remind me later'),
    // stateMachine is the state machine that will be used to transition between states
    stateMachine: {
      // onDone is the state that will be set when the user clicks on the primary button
      onDone: PreferenceState.STOP_SHOWN,
      // onDismiss is the state that will be set when the user clicks on the secondary button
      onDismiss: PreferenceState.FIRST_DISMISS,
      // onClose is the state that will be set when the user clicks on the close button
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
  [PreferenceState.SUBMIT]: {
    cooldownDays: 0,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.STOP_SHOWN,
      onDismiss: PreferenceState.FIRST_DISMISS,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
  [PreferenceState.FIRST_DISMISS]: {
    cooldownDays: 7,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.STOP_SHOWN,
      onDismiss: PreferenceState.SECOND_DISMISS,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
  [PreferenceState.SECOND_DISMISS]: {
    cooldownDays: 14,
    secondaryButtonText: _TL_('Remind me later'),
    stateMachine: {
      onDone: PreferenceState.STOP_SHOWN,
      onDismiss: PreferenceState.THIRD_DISMISS,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
  [PreferenceState.THIRD_DISMISS]: {
    cooldownDays: 30,
    secondaryButtonText: _TL_('Never show again'),
    stateMachine: {
      onDone: PreferenceState.STOP_SHOWN,
      onDismiss: PreferenceState.STOP_SHOWN,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
  [PreferenceState.STOP_SHOWN]: {
    cooldownDays: Infinity,
    secondaryButtonText: _TL_('Never show again'),
    stateMachine: {
      onDone: PreferenceState.STOP_SHOWN,
      onDismiss: PreferenceState.STOP_SHOWN,
      onClose: PreferenceState.STOP_SHOWN,
    },
  },
};
